module.exports = __webpack_public_path__ + "static/img/Great-Northern.37c8da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Great-Northern.jpg
// module id = M23O
// module chunks = 0